import PersonalBookingPageOptionViewState from './schema/PersonalBookingPageOptionViewState';
import { createStore } from 'satcheljs';
import '../mutators/initializeSettingsMutator';
import ServicesRequestStatus from './schema/ServicesRequestStatus';
import PersonalBookingPageShownView from './schema/PersonalBookingPageShownView';
import initializeServiceEditState from '../actions/initializeServiceEditState';

let initialStore: PersonalBookingPageOptionViewState = {
    services: undefined,
    servicesOrder: undefined,
    isSaving: false,
    isPerformingServiceUpdate: false,
    getServicesRequestStatus: ServicesRequestStatus.NotInitiated,
    shownView: PersonalBookingPageShownView.Main,
    serviceEditState: initializeServiceEditState(),
};

export default createStore<PersonalBookingPageOptionViewState>(
    'personalBookingPageOptionStore',
    initialStore
);
